/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  EnableMaintenanceModeRequestDto,
  IActionResult,
  MaintenanceModeInfo,
  SystemInfoDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    EnableMaintenanceModeRequestDtoFromJSON,
    EnableMaintenanceModeRequestDtoToJSON,
    IActionResultFromJSON,
    IActionResultToJSON,
    MaintenanceModeInfoFromJSON,
    MaintenanceModeInfoToJSON,
    SystemInfoDtoFromJSON,
    SystemInfoDtoToJSON,
} from '../models/index';

export interface EnableMaintenanceModeInfoRequest {
    enableMaintenanceModeRequestDto?: EnableMaintenanceModeRequestDto;
}

/**
 * 
 */
export class SystemApi extends runtime.BaseAPI {

    /**
     */
    async disableMaintenanceModeInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/system/maintenance-mode`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async disableMaintenanceModeInfo(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.disableMaintenanceModeInfoRaw(initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async enableMaintenanceModeInfoRaw(requestParameters: EnableMaintenanceModeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/system/maintenance-mode`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EnableMaintenanceModeRequestDtoToJSON(requestParameters.enableMaintenanceModeRequestDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async enableMaintenanceModeInfo(requestParameters: EnableMaintenanceModeInfoRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.enableMaintenanceModeInfoRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async getMaintenanceModeInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MaintenanceModeInfo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/system/maintenance-mode`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => MaintenanceModeInfoFromJSON(jsonValue));
    }

    /**
     */
    async getMaintenanceModeInfo(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getMaintenanceModeInfoRaw(initOverrides);
        return this.configuration.handleFunction<MaintenanceModeInfo>(response, errorHandlers);
    }

    /**
     */
    async getSystemInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SystemInfoDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/system`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => SystemInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getSystemInfo(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getSystemInfoRaw(initOverrides);
        return this.configuration.handleFunction<SystemInfoDto>(response, errorHandlers);
    }

    /**
     */
    async pingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IActionResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/system/ping`,
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => IActionResultFromJSON(jsonValue));
    }

    /**
     */
    async ping(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.pingRaw(initOverrides);
        return this.configuration.handleFunction<IActionResult>(response, errorHandlers);
    }

}
